import { CheckoutApi } from '../../api/checkout/checkoutApi';
import { Checkout, CreateCheckout } from '../../api';

export class CheckoutService {
  private readonly checkoutApi = new CheckoutApi();

  public async createCheckoutUrl(params: CreateCheckout): Promise<Checkout> {
    const order = await this.checkoutApi.createCheckoutUrl({
      ...params,
      address: {
        ...params.address,
        name: params.address.name || 'Guest Account',
      },
    });
    return order;
  }
}
